import { Flex, Table, Tbody } from '@chakra-ui/react';
import { AccessControlPermissionTypesTableHeader } from './AccessControlPermissionTypesTableHeader';
import { AccessControlPermissionTypesTableRow } from './AccessControlPermissionTypesTableRow';
import { SkeletonTable } from 'src/components/SkeletonTable/SkeletonTable';
import { PermissionType } from '@/model';

export interface AccessControlPermissionTypesTableProps {
  permissionTypes: PermissionType[];
  isLoading: boolean;
}

export const AccessControlPermissionTypesTable = ({ permissionTypes, isLoading }: AccessControlPermissionTypesTableProps) => {
  return (
    <Flex overflow='auto'>
      <Table variant='striped'>
        <AccessControlPermissionTypesTableHeader />

        <Tbody>
          {isLoading ? (
            <SkeletonTable cols={3} />
          ) : (
            permissionTypes.map(permissionType => (
              <AccessControlPermissionTypesTableRow key={permissionType.id} permissionType={permissionType} />
            ))
          )}
        </Tbody>
      </Table>
    </Flex>
  );
};
